<div class="w-4/12" [ngClass]="{'sdds-on-white-bg': darkMode}">
    <sdds-textfield type="text" ngDefaultControl name="identificationVariableId" size="md" maxlength="6"
        [value]="codeField" [disabled]="!isEditingAllowed || !isAllowed"
        (focusout)="hexCodeInputChanged.next($event.target.value)" (keyup)="setContentChanged()"
        state="{{!isValidHexCode ? 'error' : ''}}">
        <span *ngIf="!isValidHexCode" slot="sdds-helper">Hex code is not valid!. Suggested format is
            {{suggestedHexStringFormat}}.</span>
    </sdds-textfield>
</div>